// TODO: DRY up with HOSTED_CODE in @scripts/react/components/Workflows/EditorComponents/RunWorkflowModal.tsx

import { CodeSnippetEnv } from "../types";

export const HOSTED_CODE = ({
    endpoint,
    workflowName,
    workspaceUrl,
    apiKey,
    workflowParameters,
    workflowImages,
    language
}: {
    endpoint: string;
    workflowName: string;
    workspaceUrl: string;
    apiKey: string;
    workflowParameters: any[];
    workflowImages: any[];
    language: string;
}) => {
    const curlImageString = workflowImages
        .map((image) => `        "${image.name}": {"type": "url", "value": "IMAGE_URL"}`)
        .join(",\n");
    let curlParameterString;
    // const curlParameterString = workflowParameters
    //     .map((param) => {
    //         const value =
    //             param.type === "boolean"
    //                 ? param.parsed_value
    //                     ? "true"
    //                     : "false"
    //                 : JSON.stringify(param.parsed_value);
    //         return `        "${param.name}": ${value}`;
    //     })
    //     .join(",\n");

    const javascriptImageString = curlImageString.replace("        ", "            ");
    let javascriptParameterString;
    // const javascriptParameterString = curlParameterString.replace("        ", "            ");

    const pythonImageString = workflowImages
        .map((image) => `        "${image.name}": "YOUR_IMAGE.jpg"`)
        .join(",\n");

    let pythonParameterString;
    // const pythonParameterString = workflowParameters
    //     .map((param) => {
    //         const value =
    //             param.type === "boolean"
    //                 ? param.parsed_value
    //                     ? "True"
    //                     : "False"
    //                 : JSON.stringify(param.parsed_value);
    //         return `        "${param.name}": ${value}`;
    //     })
    //     .join(",\n");

    let divider = "";
    if (curlImageString && curlParameterString) {
        divider = ",";
    }

    let endpointDomain = new URL(endpoint).origin;

    const curlCode = `
\`\`\`bash
curl --location '${endpoint}' \\
--header 'Content-Type: application/json' \\
--data '{
    "api_key": "${apiKey}",
    "inputs": {${curlImageString ? "\n" + curlImageString + divider : ""}${curlParameterString ? "\n" + curlParameterString : ""}
    }
}'
\`\`\`
`;

    const javascriptCode = `
\`\`\`javascript
const response = await fetch('${endpoint}', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        api_key: '${apiKey}',
        inputs: {${javascriptImageString ? "\n" + javascriptImageString + divider : ""}${javascriptParameterString ? "\n" + javascriptParameterString : ""}
        }
    })
});

const result = await response.json();
console.log(result);
\`\`\`
`;

    const pythonCode = `

\`\`\`python
from inference_sdk import InferenceHTTPClient

client = InferenceHTTPClient(
    api_url="${endpointDomain}",
    api_key="${apiKey}"
)

result = client.run_workflow(
    workspace_name="${workspaceUrl}",
    workflow_id="${workflowName}"${
        workflowImages.length > 0
            ? `,
    images={
${pythonImageString}
    }`
            : ""
    }${
        pythonParameterString
            ? `,
    parameters={
${pythonParameterString}
    }`
            : ""
    },
    use_cache=True # cache workflow definition for 15 minutes
)
\`\`\`
`;

    if (language === CodeSnippetEnv.CURL) {
        return curlCode;
    } else if (language === CodeSnippetEnv.PYTHON) {
        return pythonCode;
    } else if (language === CodeSnippetEnv.JAVASCRIPT) {
        return javascriptCode;
    }
};
